import { Component } from '@angular/core';

export interface CardData {
    title: string;
    subtitle: string;
    icon: string;
    route: string;
    quantity?: number;
}

@Component({
  selector: 'app-home-tabs-nav',
  templateUrl: './home-tabs-nav.component.html',
  styleUrls: ['./home-tabs-nav.component.css']
})


export class HomeTabsNavComponent {
    cards: CardData[] = [
        {
          title: 'Generar Servicio',
          subtitle: 'Crea nuevos servicios para tus riders y aliados.',
          icon: 'supervised_user_circle',
          route: '/orders-create'
        },
        {
            title: 'Asignar servicios',
            subtitle: 'Asigna servicios a tus riders y aliados.',
            icon: 'assignment_ind',
            route: '/orders-assignement'
        },
        {
            title: 'Atencion al cliente',
            subtitle: 'Visualiza los reportes de tus servicios.',
            icon: 'insert_chart',
            route: '/orders-support'
        },
        {
            title: 'Riders',
            subtitle: 'Configura tus riders.',
            icon: 'motorcycle',
            route: '/manage-riders',
            quantity: 120
        },
        {
            title: 'Aliados',
            subtitle: 'Configura tus aliados.',
            icon: 'store',
            route: '/configuracion/aliados',
            quantity: 354
        }
    ];
}
